













import { listFactory } from '@/main/pages';
import { editName } from '@/main/store/listEditTypes';
import _, { toNumber } from 'lodash';
import { PageInfo } from '@/main/store/pageManager';
import { Route } from 'vue-router';
import { showAlert } from '@/main/utils/notifications';
import { Column, Row } from '@/main/utils/table';

import { HideColumns } from '@/main/components/constants';

import { apiProvider } from './api';
import { NAME } from './constants';
import { store } from './store/list';
import { NAME as ZAKAZKA, ADDITIONAL_WORK_STATUS, ADDITIONAL_JOB_STATUS } from '../constants';
import { types as zakazkaTypes } from '../store/types';

export default listFactory(NAME, store).extend({
	beforeDestroy() {
	},
	data() {
		return {
			multipleSelection: [],
		};
	},
	computed:
	{
		nahradniDilyTable(): any {
			let idColumn: number;
			_.forEach(this.table.columns, (col: Column) => {
				if (col?.propertyName?.toUpperCase() === HideColumns.STAV) {
					col.isVisible = false;
				}
				if (col?.columnId !== null) { idColumn = toNumber(col?.columnId); } else {
					col.columnId = (idColumn + 1).toString();
					idColumn = toNumber(col.columnId);
				}
			});
			return this.table;
		},
	},
	methods: {
		handleSelection(rows: []) {
			this.multipleSelection = rows;
		},
		async removeFromPageManager(to: Route): Promise<PageInfo[]> {
			this.vydejkaBeforUnload();
			return this.pageMagrBack({
				path: to.path,
				refreshPreviousPage: this.refreshPreviousPage,
			});
		},
		vydejkaBeforUnload() {
			const index = _.findIndex(this.$store.state.pageManager.pages, (page: PageInfo) => page.name === editName(ZAKAZKA));
			const previousPage: PageInfo = this.$store.state.pageManager.pages[index];
			this.$store.dispatch(`pages/${previousPage.storeModule}/${zakazkaTypes.actions.PRINT_VYDEJKA_ND}`);
		},

		async sendApprovalStatus() {
			const finalMessage = this.validateAdditionalWork();
			if (finalMessage !== '') {
				showAlert({
					message: finalMessage,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}

			this.startLoading();
			await apiProvider.sendEmailAndSmsApprovalNotification(this.props.filter.ZakazkaId, ADDITIONAL_JOB_STATUS.NON_ADDITIONAL);
			await apiProvider.setResetAdditionalJobStatusZakazkaScreen(this.props.filter.ZakazkaId, ADDITIONAL_JOB_STATUS.ADDITIONAL);
			const idColumnIndex = this.table!.cellNames!.idColumn;
			const checkboxColumnIndex = this.table!.cellNames!.ZAZNAM_ID;
			const selectedValues = this.multipleSelection.map((s: any) => [s.cells[idColumnIndex], s.cells[checkboxColumnIndex]]);
			const promises = selectedValues.map((value: any[]) => apiProvider.setAdditionalStatusForZakazkaND(value[1], ADDITIONAL_JOB_STATUS.NON_ADDITIONAL));
			await Promise.all(promises);
			this.multipleSelection = [];
			await apiProvider.deleteRejectedStatus(this.props.filter.ZakazkaId);
			await this.tableData();
			this.endLoading();
		},
		async sendRejectionStatus() {
			const finalMessage = this.validateAdditionalWork();
			if (finalMessage !== '') {
				showAlert({
					message: finalMessage,
					title: 'Information',
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.startLoading();
			await apiProvider.sendEmailAndSmsApprovalNotification(this.props.filter.ZakazkaId, ADDITIONAL_JOB_STATUS.APPROVED);
			await apiProvider.setResetAdditionalJobStatusZakazkaScreen(this.props.filter.ZakazkaId, ADDITIONAL_JOB_STATUS.PENDING);

			const idColumnIndex = this.table!.cellNames!.idColumn;
			const checkboxColumnIndex = this.table!.cellNames!.ZAZNAM_ID;
			const selectedValues = this.multipleSelection.map((s: any) => [s.cells[idColumnIndex], s.cells[checkboxColumnIndex]]);
			const promises = selectedValues.map((value: any[]) => apiProvider.setAdditionalStatusForZakazkaND(value[1], ADDITIONAL_JOB_STATUS.APPROVED));
			await Promise.all(promises);
			this.multipleSelection = [];
			await apiProvider.deleteRejectedStatus(this.props.filter.ZakazkaId);
			await this.tableData();
			this.endLoading();
		},
		validateAdditionalWork(): string {
			let finalMessage = '';
			const idAdditionalJobColumnIndex = this.table!.cellNames!.IS_ADDITIONAL;
			const idAdditionalStatusColumnIndex = this.table!.cellNames!.ADDITIONAL_JOB_STATUS;
			const idNdNrColumnIndex = this.table!.cellNames!.ND_NR;

			const alreadyActionedParts = this.multipleSelection.reduce((record: string, sum: Row) => {
				const validData = sum.cells !== null
					&& sum.cells[idAdditionalStatusColumnIndex] !== null
					&& sum.cells[idAdditionalStatusColumnIndex] !== ''
					&& sum.cells[idAdditionalStatusColumnIndex].includes(ADDITIONAL_WORK_STATUS.CUSTOMER_APPROVAL_PENDING) <= 0;

				return validData ? record + sum.cells[idNdNrColumnIndex] : record;
			}, '');

			const notAdditionalParts = this.multipleSelection.reduce((record: string, sum: Row) => {
				const validData = sum.cells !== null && sum.cells[idAdditionalJobColumnIndex] !== null && sum.cells[idAdditionalJobColumnIndex] !== true;
				return validData ? record + sum.cells[idNdNrColumnIndex] : record;
			}, '');

			if (alreadyActionedParts !== '') {
				finalMessage = this.LocalizeAndReplace(this.LocalizeChyboveHlasky('PartsActioned'), { key: '#ActionedParts#', value: alreadyActionedParts });
			}
			if (notAdditionalParts !== '') {
				finalMessage = `${finalMessage}\n \n ${this.LocalizeAndReplace(this.LocalizeChyboveHlasky('PartsNotAdditional'),
					{ key: '#NotAdditionalPart#', value: notAdditionalParts })}`;
			}
			return finalMessage;
		},
	},
});
